module.exports = __webpack_public_path__ + "img/pat.4a874971.png";